// Default labels shown before the server's own `label` arrives on a
// `stage STARTED` event (and reused if a later event omits it). Mirrors the
// server copy in docs/sse-course-creation-api-contract.md so the stepper
// never renders a blank line during the gap before the first frame.
export const COURSE_CREATE_STAGE_DEFS = [
  { key: 'MODERATION', label: 'Checking your topic' },
  { key: 'OUTLINE', label: 'Planning your syllabus' },
  { key: 'SYLLABUS', label: 'Saving your course' },
  { key: 'FIRST_LESSON', label: 'Writing your first lesson' },
];

export const INITIAL_COURSE_CREATE_STREAM = {
  stages: COURSE_CREATE_STAGE_DEFS.map(({ key, label }) => ({ key, label, status: 'pending' })),
  result: null,
  errored: null,
};

/**
 * Pure reducer over the course-creation SSE events. Folds `stage`/`complete`/
 * `error` frames into a stepper-friendly model. See
 * docs/sse-course-creation-api-contract.md for the wire shapes and the
 * per-stage truth table (`completed`/`total` are ABSENT, never 0/null, when
 * not applicable).
 */
export function applyCourseCreateEvent(state, { event, data }) {
  switch (event) {
    case 'stage': {
      const stages = state.stages.map((stage) => {
        if (stage.key !== data.stage) return stage;
        if (data.status === 'STARTED') {
          return { ...stage, status: 'active', label: data.label ?? stage.label };
        }
        if (data.status === 'DONE') {
          const next = { ...stage, status: 'done', label: data.label ?? stage.label };
          if (typeof data.completed === 'number') next.completed = data.completed;
          if (typeof data.total === 'number') next.total = data.total;
          return next;
        }
        return stage;
      });
      return { ...state, stages };
    }
    case 'complete':
      return { ...state, result: { courseId: data.courseId, firstLessonId: data.firstLessonId } };
    case 'error':
      return { ...state, errored: { code: data.error, message: data.message } };
    default:
      return state;
  }
}
